import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';
import { useRoutes } from '../hooks/useRoutes';
import { AppStoreBadges } from './AppStoreBadges';
import './SiteFooter.css';
import './AppStoreBadges.css';

/** Public sayfaların altında görünen ortak footer (gizlilik linki — store zorunlu). */
export function SiteFooter({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n();
  const { r } = useRoutes();
  const { pathname } = useLocation();

  // Oyun/lobi/oda gibi tam ekran sayfalarda gösterme
  const HIDE_ON = [
    '/oyna', '/en/play',
    '/cozucu', '/en/solver',
    '/lobby', '/room/', '/auth',
    '/profile', '/friends', '/challenge', '/user/',
    '/gunluk', '/en/daily',
  ];
  if (HIDE_ON.some(p => pathname.startsWith(p))) return null;

  const f = t.footer;
  const year = new Date().getFullYear();

  return (
    <footer className={`site-footer${compact ? ' site-footer--compact' : ''}`}>
      <div className="site-footer-inner">
        <div className="site-footer-links">
          <Link to={r('privacy')}>{f.privacyLink}</Link>
          <span className="site-footer-sep">·</span>
          <Link to={r('tutorial')}>{f.howToPlayLink}</Link>
          <span className="site-footer-sep">·</span>
          <Link to={r('education')}>{f.techniquesLink}</Link>
          <span className="site-footer-sep">·</span>
          <a href={`mailto:${f.contactEmail}`}>{f.contactLink}</a>
        </div>
        {!compact && <div className="site-footer-store">
          <AppStoreBadges />
        </div>}
        <div className="site-footer-meta">
          © {year} Sudoku Area
        </div>
      </div>
    </footer>
  );
}
